import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgThumbsDownOutline = function SvgThumbsDownOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.51622 6.41145C4.51622 6.41145 4.51622 6.41145 4.51622 6.41145L3.6797 11.9115C3.47251 13.2737 4.52642 14.5 5.90255 14.5H11.1427C11.3617 14.5 11.5699 14.5958 11.7124 14.7622C11.8549 14.9286 11.9175 15.149 11.8837 15.3655L11.3084 19.0574C11.1902 19.8158 11.7764 20.5 12.5425 20.5C12.6406 20.5 12.7294 20.4437 12.7702 20.3643L16.6556 12.8183V4.5H6.73907C5.62822 4.5 4.68346 5.31192 4.51622 6.41145ZM18.1556 4.5V12.5H20.4035C20.5416 12.5 20.6535 12.3881 20.6535 12.25V4.75C20.6535 4.61192 20.5415 4.5 20.4035 4.5H18.1556ZM17.7343 14H20.4035C21.37 14 22.1535 13.2165 22.1535 12.25V4.75C22.1535 3.78352 21.37 3 20.4035 3H6.73907C4.88632 3 3.3119 4.35404 3.03328 6.18589L2.19676 11.6859C2.19676 11.6859 2.19676 11.6859 2.19676 11.6859C1.85162 13.9551 3.60722 16 5.90255 16H10.2667L9.82631 18.8264C9.82631 18.8264 9.82632 18.8264 9.82631 18.8264C9.56652 20.4934 10.855 22 12.5425 22C13.1934 22 13.8016 21.6377 14.1037 21.0513L17.7343 14Z"
  })));
};

export { SvgThumbsDownOutline as ReactComponent };
//# sourceMappingURL=thumbs--down-outline.svg.js.map
